module.exports = __webpack_public_path__ + "img/icon1.d23ace36.png";